import { ReactNode } from 'react';

import {
  Icon,
  IconButton,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import { Box } from '@mui/system';

import { useDrawerContext } from '../contexts';

interface ILayoutBaseDePaginaProps {
  children: React.ReactNode;
  barraDeFerramentas?: ReactNode;
}

export const LayoutBaseDeDashboard: React.FC<
  ILayoutBaseDePaginaProps
> = ({ children, barraDeFerramentas }) => {
  const smDown = useMediaQuery(
    (theme: Theme) => theme.breakpoints.down('sm')
  );

  const mdDown = useMediaQuery(
    (theme: Theme) => theme.breakpoints.down('md')
  );

  const theme = useTheme();

  const { toggleDrawerOpen } = useDrawerContext();

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        bgcolor: theme.palette.background.default,
      }}
    >
      {/* HEADER MOBILE */}
      <Box
        display="flex"
        alignItems="center"
        flexShrink={0}
        height={theme.spacing(
          smDown ? 6 : mdDown ? 8 : 0
        )}
      >
        {smDown && (
          <IconButton onClick={toggleDrawerOpen}>
            <Icon>menu</Icon>
          </IconButton>
        )}
      </Box>

      {/* TOOLBAR */}
      {barraDeFerramentas && (
        <Box flexShrink={0}>
          {barraDeFerramentas}
        </Box>
      )}

      {/* CONTEUDO */}
      <Box
        sx={{
          flex: 1,
          width: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          boxSizing: 'border-box',
          px: { xs: 1, sm: 2 },
          pb: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};